import { useFormContext, Controller } from 'react-hook-form';
import type { InputHTMLAttributes } from 'react';
import type { FieldError } from 'react-hook-form';
import PersonInnInput from './PersonInnInput';

export type FormPersonInnInputProps = InputHTMLAttributes<HTMLInputElement> & {
  error?: FieldError;
  name: string;
  label?: string;
  unmasked?: boolean;
};

function FormPersonInnInput({
  error,
  name,
  ...restFieldProps
}: FormPersonInnInputProps): JSX.Element {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onBlur, onChange, value } }) => (
        <PersonInnInput
          status={error && 'error'}
          extraText={error?.message}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
          {...restFieldProps}
        />
      )}
    />
  );
}

export default FormPersonInnInput;
